import { Component, OnInit } from '@angular/core';
import { ALLUMNI } from 'src/app/constant/auto/allumni.constant';

@Component({
  standalone: false,
  selector: 'app-alumni',
  templateUrl: './alumni.component.html',
  styleUrls: ['./alumni.component.css']
})
export class AlumniComponent implements OnInit {

  readonly alumniData = ALLUMNI;
  constructor() { }

  ngOnInit() {
  }

}
